import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";

function formatErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="w-full max-w-sm">
        <p className="font-bodoni text-5xl tracking-tight text-center mb-2">FUNKY<span className="volt">.</span></p>
        <p className="label text-[#8A8F99] text-center mb-12">Funky Apparel · Studio Access</p>
        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="label block mb-2">Email</label>
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full h-12 px-4 bg-transparent border border-[#0B0E14] focus:ring-1 focus:ring-[#0B0E14] focus:outline-none" />
          </div>
          <div>
            <label className="label block mb-2">Password</label>
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full h-12 px-4 bg-transparent border border-[#0B0E14] focus:ring-1 focus:ring-[#0B0E14] focus:outline-none" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-red-700">{error}</p>}
          <button data-testid="login-submit" disabled={loading} className="w-full bg-[#0B0E14] text-[#EDEEF1] h-14 label hover:bg-[#1B2233] transition-colors disabled:opacity-50">
            {loading ? "Entering…" : "Enter Studio"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
